import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Observable } from "rxjs/Rx";
import { SxHttpService } from "./sxHttp.service";
import { EntityChildsContext } from "app/private/entity/entityWithChilds/model/EntityChildsContext";
import { BusinessLogic } from "../model/interfaces/businessLogic.interface";
import { Marketplace } from "../model/classes/marketplace.class";

@Injectable()
export class BusinessLogicService {
  private businessLogicService = "api/BusinessLogic";
  private businessLogicSubscriptionSrv = "api/BussinesLogicSubscription";

  constructor(private sxHttp: SxHttpService) {}

  //#region standard persistence
  getAll(): Observable<BusinessLogic[]> {
    return this.sxHttp
      .get(this.businessLogicService + "/GetAll")
      .map((response) => response.json().data as BusinessLogic[]);
  }

  getAllSubscribed(
    organizationCode: string,
    subscriptionCode: string,
    channelCode: string,
    productCode: string
  ): Observable<BusinessLogic[]> {
    let context: EntityChildsContext = {
      organizationCode: organizationCode,
      subscriptionCode: subscriptionCode,
      channelCode: channelCode,
      productCode: productCode,
    };
    return this.sxHttp
      .post(`${this.businessLogicSubscriptionSrv}/GetSubscription`, context)
      .map((response) => {
        return response.json().data as BusinessLogic[];
      });
  }

  getById(idBusinessLogic: string): Observable<BusinessLogic> {
    return this.sxHttp
      .get(this.businessLogicService + "/GetById" + "/" + idBusinessLogic)
      .map((response) => response.json().data as BusinessLogic);
  }

  delete(idBusinessLogic: string): Promise<Boolean> {
    return this.sxHttp
      .delete(this.businessLogicService + "/Delete" + "/" + idBusinessLogic)
      .toPromise()
      .then((result) => result.json().data);
  }
  
  unsubscribe(idBusinessLogic: string): Promise<Boolean> {
    return this.sxHttp
      .delete(this.businessLogicSubscriptionSrv + "/Delete" + "/" + idBusinessLogic)
      .toPromise()
      .then((result) => result.json().data);
  }

  create(model: BusinessLogic): Promise<any> {
    return this.sxHttp
      .post(this.businessLogicService + "/Create", model)
      .toPromise()
      .then((response) => {
        return response.json().data;
      });
  }

  update(model: BusinessLogic): Promise<any> {
    return this.sxHttp
      .post(this.businessLogicService + "/Update", model)
      .toPromise()
      .then((response) => {
        return response.json().data;
      });
  }

  getOrganizationList(): Observable<BusinessLogic> {
    return this.sxHttp
      .get(this.businessLogicService + "/GetOrganizationList")
      .map((response) => {
        return response.json().data as BusinessLogic;
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/businessLogic.service.ts